import React from 'react';

export default function Contact_us() {
    return (

        <div className='row'>
            <div className='col-md-2 '></div>
            <div className='col-md-8 mt-5 mx-5'>
               <p> If you are having issues with any portion of the website, please use the contact information below to obtain assistance.</p>
               <p className="mx-5" > E-mail:<a href="mailto:support@firstverify.com">support@firstverify.com</a><br></br><br></br>
                Phone:	402-562-5930</p>
            </div>
            <div className='col-md-2 '></div>
        </div>
    )
}
